import { useReactive } from 'ahooks';
import { AppModalControlProps } from '../../interfaces/app';

export type ReturnProps = AppModalControlProps;

export const useAppModalControls = (): [ReturnProps] => {
  const modalVisibleState = useReactive({ isOpen: false });

  const open = (): void => {
    modalVisibleState.isOpen = true;
  };

  const close = (): void => {
    modalVisibleState.isOpen = false;
  };

  return [
    {
      isOpen: modalVisibleState.isOpen,
      open,
      close
    }
  ];
};
